<template>
  <el-dialog
    :title="$t('salesBill.message.businessMatching')"
    fullscreen
    :visible.sync="defaultVisible"
    width="1200px"
  >
    <sirui-search
      v-if="searchColumns.length"
      ref="siruiSearch"
      :query="query"
      :columns="searchColumns"
      @resetBtnClick="resetBtnClick"
      @searchBtnClick="search"
    ></sirui-search>
    <div class="main-content">
      <div class="m-b">
        <span>{{ $t('salesBill.batchPickingDialog.text.toPickNumber') }}{{ toPickedAmount }}</span>
        <span
          >{{ $t('salesBill.batchPickingDialog.text.hasPickNumber') }}{{ hasPickedAmount }}</span
        >
        <el-button type="primary" size="mini" @click="clearRecrods">清空</el-button>
      </div>
      <sirui-table
        :rowKey="propCode || 'id'"
        ref="siruiTable"
        :loading="load"
        :data="tableData"
        :paging="page"
        :checkRowKeys="checkRowKeys"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handlePagination"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-if="isMultiple"
          type="checkbox"
          width="50"
          fixed="left"
        ></vxe-table-column>
        <vxe-table-column v-else type="radio" width="50" fixed="left"></vxe-table-column>
        <vxe-table-column
          v-for="(item, index) in columnList"
          :key="index"
          :type="item.type"
          :fixed="item.fixed"
          :field="item.prop"
          :title="item.label"
          :sortable="item.sortable"
          :visible="item.visible"
        >
          <template slot-scope="scope">
            <span v-if="item.prop === 'pickingQuantity'">
              <input-number
                v-model="scope.row.pickingQuantity"
                :max="scope.row.availableSaleQuantityChange"
                :precision="3"
                @input="(val) => pickingQuantityChange(val, scope.row, scope)"
              ></input-number>
            </span>
            <span v-else>{{ scope.row[item.prop] }}</span>
          </template>
        </vxe-table-column>
      </sirui-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">{{ $t('salesBill.message.cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{
        $t('salesBill.message.confirm')
      }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import { filterEmpty } from '@/common/js/util';
  import API from '@/api/purchaseSalesCenter/salsManage/salesLadingbill.js';
  import MCAPI from '@/api/wareHouse/mcInbound.js';
  import SiruiSearch from '@/components/SiruiSearch';
  import SiruiTable from '@/components/SiruiTable';
  import inputNumber from '@/components/form-item/input-number';
  import XEUtils from 'xe-utils';
  export default {
    props: {
      basicData: {
        type: Object,
        default: () => {},
      },
      fromFlag: {
        type: String,
        default: () => 'batchMatchingResults', //batchMatchingResults  rowInfo表示从哪个组件打开的弹框
      },
      storageLadingPickingDetailList: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      SiruiSearch,
      SiruiTable,
      inputNumber,
    },
    data() {
      return {
        defaultVisible: false,
        load: false,
        tableData: [],
        query: {},
        multipleSelection: [],
        propCode: '',
        page: true,
        checkRowKeys: [],
        isMultiple: true,
        hasPickedAmount: 0,
        toPickedAmount: 0,
        totalToPickedAmount: 0,
        chooseIndex: '', //拣配的商品明细的行序号
        productNo: '',
        productDesc: '',
        flag: true, //true 表示拣配弹框 false表示原材料行弹框
        pickedTemp: [], //已拣配暂存
      };
    },
    computed: {
      searchColumns() {
        // const departmentUrl = this.companyCode
        //   ? `${COMPANY_API.GET_COMPANY_DETAIL_API}/${this.companyCode}`
        //   : '';
        return [
          {
            type: 'input',
            prop: 'ladingBusinessDepartmentName',
            name: this.$t('salesBill.batchPickingDialog.search.ladingBusinessDepartmentName'),
            disabled: true,
          },
          {
            type: 'input',
            prop: 'storageName',
            name: this.$t('salesBill.batchPickingDialog.search.storageName'),
            disabled: true,
          },
          {
            type: 'input',
            prop: 'productDesc',
            name: this.$t('salesBill.batchPickingDialog.search.productDesc'),
            disabled: true,
          },
          {
            type: 'startDaterangePicker',
            prop: 'startGmtCreate',
            name: this.$t('salesBill.batchPickingDialog.search.startGmtCreate'),
          },
          {
            type: 'endDaterangePicker',
            prop: 'endGmtCreate',
            name: this.$t('salesBill.batchPickingDialog.search.endGmtCreate'),
          },
          {
            type: 'input',
            prop: 'contractInternalNo',
            name: this.$t('salesBill.batchPickingDialog.search.contractInternalNo'),
          },
          {
            type: 'input',
            prop: 'batchNo',
            name: this.$t('salesBill.batchPickingDialog.search.batchNo'),
          },
          {
            type: 'input',
            prop: 'inboundNo',
            name: this.$t('salesBill.batchPickingDialog.search.inboundNo'),
          },
          {
            type: 'input',
            prop: 'partnerName',
            name: '供应商',
          },
          {
            type: 'input',
            prop: 'marineLadingNo',
            name: this.$t('salesBill.batchPickingDialog.search.marineLadingNo'),
          },
          {
            type: 'input',
            prop: 'warehouseReceiptsNo',
            name: this.$t('salesBill.batchPickingDialog.search.warehouseReceiptsNo'),
          },
          {
            type: 'input',
            prop: 'settleBatchNo',
            name: this.$t('salesBill.batchPickingDialog.search.settleBatchNo'),
          },
          {
            type: 'input',
            prop: 'distributionBatchNo',
            name: this.$t('logistics.commodityMarket.distributionBatchNo'),
          },
          {
            type: 'input',
            prop: 'nameVoyageLicense',
            name: this.$t('salesBill.batchPickingDialog.search.storageBatch'),
          },
        ];
      },
      columnList() {
        return [
          {
            prop: 'batchNo',
            label: this.$t('salesBill.batchPickingDialog.table.batchNo'),
            fixed: 'left',
          },
          {
            prop: 'storageQuantity',
            label: this.$t('salesBill.batchPickingDialog.table.storageQuantity'),
            fixed: 'left',
          },
          { prop: 'orderNo', label: this.$t('salesBill.batchPickingDialog.table.orderNo') },
          { prop: 'availableSaleQuantityChange', label: '可用数量' },
          {
            prop: 'pickingQuantity',
            label: this.$t('salesBill.batchPickingDialog.table.pickingQuantity'),
            visible: this.fromFlag != 'rowInfo',
          },
          { prop: 'storageName', label: this.$t('salesBill.batchPickingDialog.table.storageName') },
          { prop: 'productName', label: this.$t('salesBill.batchPickingDialog.table.productName') },
          {
            prop: 'distributionBatchNo',
            label: this.$t('logistics.commodityMarket.distributionBatchNo'),
          },
          { prop: 'gmtCreate', label: this.$t('salesBill.batchPickingDialog.table.inboundDate') },
          { prop: 'inboundNo', label: this.$t('salesBill.batchPickingDialog.table.inboundNo') },
          {
            prop: 'nameVoyageLicense',
            label: this.$t('salesBill.batchPickingDialog.search.storageBatch'),
          },
          {
            prop: 'contractInternalNo',
            label: this.$t('salesBill.batchPickingDialog.table.contractInternalNo'),
          },
          {
            prop: 'businessUnitPriceWithTax',
            label: this.$t('salesBill.batchPickingDialog.table.businessUnitPriceWithTax'),
          },
          {
            prop: 'financeUnitPriceWithTax',
            label: this.$t('salesBill.batchPickingDialog.table.financeUnitPriceWithTax'),
          },
          { prop: 'partnerName', label: this.$t('salesBill.batchPickingDialog.table.partnerName') },
          {
            prop: 'marineLadingNo',
            label: this.$t('salesBill.batchPickingDialog.table.marineLadingNo'),
          },
          {
            prop: 'warehouseReceiptsNo',
            label: this.$t('salesBill.batchPickingDialog.table.warehouseReceiptsNo'),
          },
          {
            prop: 'settleBatchNo',
            label: this.$t('salesBill.batchPickingDialog.table.settleBatchNo'),
          },
        ];
      },
    },
    methods: {
      // 初始化查询参数
      initQuery() {
        const query = {};
        this.searchColumns.forEach((item) => {
          if (item.prop) {
            if (typeof item.prop === 'string') {
              query[item.prop] = undefined;
            } else {
              item.prop.forEach((prop) => {
                query[prop] = undefined;
              });
            }
          }
        });
        this.query = Object.assign({}, query, this.query);
      },
      getData() {
        if (!API) return;
        this.load = true;
        const query = this.getQuery();
        if (this.$route.query.ladingNo && !this.$route.query.copy) {
          query.ladingNo = this.$route.query.ladingNo;
        }
        query.isMoreZero = 1;
        this.$axios
          .post(MCAPI.LIST_STORAGE_BATCH, filterEmpty(query))
          .then((res) => {
            this.load = false;
            if (0 == res.data.code) {
              if (this.page) {
                this.tableData = res.data.data.list;
                console.log(this.pickedTemp);
                let existBatch =
                  this.pickedTemp.map((item) => item.batchNo || item.businessInboundBatchNo) || [];
                this.tableData.map((item) => {
                  item.availableSaleQuantityChange = item.availableQuantity;
                  // 判断是否有已拣配批次 已存在则填入
                  if (existBatch[0] && existBatch.indexOf(item.batchNo) != -1) {
                    let obj = this.pickedTemp.find((it) => {
                      if (it.batchNo) {
                        return it.batchNo == item.batchNo;
                      } else {
                        return it.businessInboundBatchNo == item.batchNo;
                      }
                    });
                    item.pickingQuantity = obj.pickingQuantity;
                  }
                  return item;
                });
                this.$refs.siruiTable.setPageTotal(res.data.data.total);
              } else {
                this.tableData = res.data.data;
              }
              //重新加载表格
              this.$refs.siruiTable.reloadTable(this.tableData);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
            }
          })
          .catch(() => {
            this.load = false;
          });
      },
      // 清空
      clearRecrods() {
        this.$confirm('此操作将清空当前记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        })
          .then(() => {
            this.hasPickedAmount = 0;
            this.hasPickedAmountArr = [];
            this.toPickedAmount = this.$cal.calCommon(
              this.totalToPickedAmount,
              this.hasPickedAmount,
              '-'
            );
            this.pickedTemp = [];
            this.tableData = this.tableData.map((item) => {
              item.pickingQuantity = null;
              return item;
            });
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除',
            });
          });
      },
      // 弹窗确认
      handleConfirm() {
        this.changeResultPick();
      },
      changeResultPick() {
        let tableData = this.$refs.siruiTable.data;
        let resultArr = [];
        tableData.map((item) => {
          if (item.pickingQuantity && item.pickingQuantity != 0) {
            item.productNo = item.productDetailNo;
            item.inboundPickNo = this.chooseIndex;
            item.fromCurrencyCode = item.ladingCurrency;
            item.actualSendQuantity = item.pickingQuantity;
            resultArr.push(item);
          } else {
            XEUtils.remove(this.pickedTemp, (it) => {
              if (it.batchNo) {
                return it.batchNo == item.batchNo;
              } else {
                return it.businessInboundBatchNo == item.batchNo;
              }
            });
          }
        });

        if (resultArr.length == 0) {
          this.$message({
            showClose: true,
            message: '请输入拣配数量',
            type: 'error',
          });
          return;
        }

        //拣配金额转换
        let params = {
          toCurrencyCode: this.basicData.ladingCurrency,
          storageBatchList: resultArr,
        };
        this.$axios
          .post(API.GET_EXCHANGE_CURRENCY, params)
          .then((res) => {
            if (res.data.data) {
              resultArr = res.data.data.storageBatchList;
              this.calPicked(resultArr);
            }
          })
          .finally(() => {
            if (this.toPickedAmount == 0) {
              this.$emit('changeResult', this.pickedTemp, this.chooseIndex);
              this.defaultVisible = false;
              // return;
            } else if (this.toPickedAmount < 0) {
              this.$message({
                showClose: true,
                message: '拣配数超过总待数量',
                type: 'error',
              });
            }
          });
      },
      // 计算拣配数量
      calPicked(resultArr) {
        let existBatch =
          this.pickedTemp.map((item) => item.batchNo || item.businessInboundBatchNo) || [];
        resultArr.map((result) => {
          if (existBatch.indexOf(result.batchNo) == -1) {
            // 不存在则新增
            this.pickedTemp.push(result);
          } else {
            // 已存在则更新
            let index = this.pickedTemp.findIndex((item) => {
              if (item.batchNo) {
                return item.batchNo == result.batchNo;
              } else {
                return item.businessInboundBatchNo == result.batchNo;
              }
            });
            this.pickedTemp[index] = result;
          }
        });
        let hasPickedAmountArr = this.pickedTemp.map((item) => item.pickingQuantity);
        this.hasPickedAmount = XEUtils.reduce(hasPickedAmountArr, (previous, item) =>
          this.$cal.calCommon(previous, item, '+')
        ); // 176 hasPickedAmountArr.
        this.toPickedAmount = this.$cal.calCommon(
          this.totalToPickedAmount,
          this.hasPickedAmount,
          '-'
        );
      },
      // 弹窗关闭
      close() {
        this.defaultVisible = false;
      },
      // 获取查询参数
      getQuery() {
        // 分页数据
        const { pageNum, pageSize } = this.$refs.siruiTable.page;
        const query = this.query;
        const result = Object.assign({}, this.extraData, query, {
          pageNum,
          pageSize,
        });
        this.searchColumns.forEach((item) => {
          if (item.getSearchCode) {
            const arr = query[item.prop];
            if (arr && arr.length) {
              const codes = arr.map((code) => {
                return code[item.getSearchCode];
              });
              // 单选改第一个，多选给多个
              result[item.prop] = item.isMultiple ? codes[0] : codes;
            }
          }
        });
        return result;
      },
      // 点击分页
      handlePagination() {
        this.getData();
      },
      // 分页条数改变
      handleSizeChange() {
        this.getData();
      },
      // 搜索
      search() {
        this.$refs.siruiTable.setPageNum(1);
        this.getData();
      },
      // 表格选中行
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
      // 重置
      resetBtnClick() {
        this.$refs.siruiTable.setPageNum(1);
        this.$refs.siruiTable.setPageSize(10);
        this.getData();
      },
      //从外面选择行 做为拣配搜索的默认条件 如 商品 仓库 部门
      chooseGoods(row, chooseIndex, baseInfo) {
        this.defaultVisible = true;
        this.flag = true;
        this.query.productDesc = row[0].productDesc;
        // this.query.ladingBusinessDepartmentName = row[0].contractBusinessDepartmentName || row[0].departmentName;
        // this.query.ladingBusinessDepartmentName = this.basicData.inboundDepartmentName
        this.pickedTemp = []; //清空上次拣配的缓存
        this.hasPickedAmount = 0; // 已拣配数量为0
        this.toPickedAmount = row[0].ladingQuantity; //默认带过来的待拣配数量等于提单数量
        this.totalToPickedAmount = row[0].ladingQuantity; //默认带过来的待拣配数量等于提单数量 开始的总待提单数量
        let storageLadingPickingDetailList = this.storageLadingPickingDetailList.filter(
          (item) => item.productNo == row[0].productNo
        );
        if (storageLadingPickingDetailList[0]) {
          this.pickedTemp = XEUtils.clone(storageLadingPickingDetailList, true); //加载已拣配过的数据
          this.hasPickedAmount = row[0].ladingQuantity;
          this.toPickedAmount = 0;
        }
        // //默认带三个固定条件
        this.query.batchDepartmentNo =
          row[0].contractBusinessDepartment || baseInfo.inboundDepartmentCode;
        // this.query.storageName =baseInfo.outboundStorageName||'';
        this.query.storageNo = baseInfo.outboundStorageNo || '';
        this.query.productDetailNo = row[0].productNo;
        this.chooseIndex = chooseIndex;
        this.productNo = row[0].productNo || '';
        this.productDesc = row[0].productDesc || '';
        this.ladingUnit = row[0].ladingUnit || '';
        this.ladingUnitName = row[0].ladingUnitName || '';
        this.$nextTick(() => {
          // 进入弹窗查询数据
          this.search();
        });
      },
      //批次行拣配数量发生变化
      pickingQuantityChange(val, row, scope) {
        console.log(val, row, scope);
        return;
        // clearTimeout(this.timeout)
        // this.timeout = setTimeout(() => {
        //   // row.availableSaleQuantityChange = row.availableSaleQuantity - Number(val);//每行可售数量减少
        //   // row.availableSaleQuantityChange =this.$cal.accSub(row.availableSaleQuantity,val)//每行可售数量减少
        //   // row.availableSaleQuantityChange=XEUtils.toFixedNumber(row.availableSaleQuantityChange, 3);
        //   let tableData = this.$refs.siruiTable.data;
        //   const addNum=[]
        //   tableData.forEach(item => {
        //     addNum.push(item.pickingQuantity||0)
        //   })
        //   Promise.resolve(this.calculateAdd(addNum)).then(res => {
        //     this.hasPickedAmount=res
        //     this.toPickedAmount = this.$cal.accSub(this.totalToPickedAmount, this.hasPickedAmount)
        //     this.toPickedAmount=XEUtils.toFixedNumber(this.toPickedAmount, 3);
        //   });
        //   }, 1000)
      },
      // 接口加法计算
      calculateAdd(adds) {
        return new Promise((resolve, reject) => {
          this.$axios.post(API.GET_ADD_AMOUNT, { adds }).then((res) => {
            if (0 == res.data.code) {
              resolve(res.data.data);
            } else {
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'error',
              });
              reject();
            }
          });
        });
      },
    },
  };
</script>

<style scoped>
  .el-dialog__body {
  }
</style>
